import React from "react";

import { useTracking } from "react-tracking";
import { useDispatch, useSelector } from "react-redux";
import { startRegisterTrackingHistory } from "../../app/actions/trackingHistoryActions";
import AdminDataVisionRoutes from "./AdminDataVisionRoutes";

const AdminDataVisionScreen = () => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);

  const { Track } = useTracking(
    {
      module: "Import Data Vision",
      page: "Import Data Vision Screen",
      user_id: user.user_id,
      user_name: user.user_name,
      
    },
    {
      dispatch: (data) => {

        dispatch(startRegisterTrackingHistory(data));
        
      },
    }
  );

  return (
    <div>
      <Track>
        <AdminDataVisionRoutes />
      </Track>
    </div>
  );
};

export default AdminDataVisionScreen;
